import cloudinaryConfig from '../utils/cloudinaryConfig';


import GridModel from './gridmodel';

const LotModel = GridModel.extend({
    defaults: {
        'auctionLotBidUrl': '',
        'auctionLotDisplayTypeId': 1,
        'currentySign': '',
        'description': '',
        'hammerPlusBP': 0,
        'imagePath': '',
        'is360View': false,
        'isHideDisplay': false,
        'isSoldOverride': false,
        'isViewInRoom': true,
        'lotImages': [],
        'lotNumberFull': '',
        'lotThumbs': [],
        'maker': null,
        'newImagePath': '',
        'showAdvanceBidButton': true,
        'showSaleOffers': false,
        "lotNumber": 0,
        "lotNumberSuffix": "",
        "saleNumber": "",
        'detailVideoUrl': '',
        'showInquireButton': 0,
        'showSoldPrice': 1,
        'showSoldLabel': 1,
        'showEstimateText': 1
    },
    idAttribute: 'lotNumber',
    urlRoot: `${$('body').data('domain')}/api/Lots/Post`,
    initialize() {
        this.set('id', this.id);
        GridModel.prototype.initialize.call(this);
    },
    save(attrs) {
        const q = $.Deferred();
        this.set(attrs);
        GridModel.prototype.save.call(this, this.attributes, {
            success: (resp) => {
                resp.set('message', 'Lot saved.');
                q.resolve(resp);
            },
            error: (err, response) => {
                console.log('saveCB err: ', err);
                q.reject(err, response);
            }
        });

        return q.promise();
    },
    updateImages() {
        const useCloudinary = this.get('useCloudinary');
        const imageVersion = this.get('imageVersion');
        const cloudinaryImages = this.get('lotImages')
            .map(images => ({
                ...images,
                imagePath: getImage(images.imagePath, useCloudinary, imageVersion)
            }));

        function getImage(imagePath, useCloudinary, imageVersion) {
            if (useCloudinary) {
                return cloudinaryConfig.url(imagePath, {
                    transformation: 'Website_LotDetailThumb',
                    //fetch_format: 'auto',
                    version: imageVersion
                });
            } else {
                if (imagePath && imagePath.toLowerCase().indexOf("phillipsds") < 0) {
                    return `${imagePath}/120/400`;
                } else {
                    return `https://www.phillips.com/Xigen/image.ashx?path=${imagePath}&width=120&height=400`;
                }
            }
        }
        this.set({ 'lotImages': cloudinaryImages });
    }
});

export default LotModel;
